import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../Components/Cta";
import {
  CustomFileUpload,
  Input,
  ToggleInput,
} from "../../Components/FormElements";
import { APIService } from "../../Service";
import { Loader } from "../../Components/Other";
import { toast } from "react-toastify";
import { DeleteModal } from "../../Components/Modals";

export default function ManageGoalDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  // --- form state hooks ---
  const [tag, setTag] = useState("");
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [cardData, setCardData] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [recommended, setRecommended] = useState(false);
  const [minSip, setMinSip] = useState("");
  const [lumpsum, setLumpSum] = useState("");
  const [loading, setLoading] = useState(false);

  // --- error state hooks ---
  const [linkError, setLinkError] = useState(false);
  const [tagError, setTagError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [minSipError, setMinSipError] = useState(false);
  const [lumpsumError, setLumpsumError] = useState(false);

  // --- load existing goal if editing ---
  useEffect(() => {
    if (!id) return;
    setLoading(true);
    _getGoalDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // service to getDetails
  const _getGoalDetail = () => {
    const is_post = true;
    const data = [{ goal_style_id: id }];

    APIService(is_post, "goal/view-detail", data)
      .then((response) => {
        if (response.status_code === 200) {
          const goal = response.data[0];
          setCardData(goal);
          setLink(goal.name || "");
          setTag(goal.tags || "");
          setMinSip(goal.minimum_sip || "");
          setLumpSum(goal.minimum_lumpsum || "");
          setFile(goal.image || null);
          setImageLink(goal.image);
          setRecommended(goal.recommended);
          setLoading(false);
        } else {
          console.error(response);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  // service to save
  const _upsertGoalDetail = () => {
    const is_post = true;
    const payload = [
      {
        goal_style_id: id,
        name: link,
        image: imageLink,
        min_sip: minSip,
        min_lumpsum: lumpsum,
        tag,
        recommended,
      },
    ];
    APIService(is_post, "goal/upsert", payload)
      .then((response) => {
        if (response.status_code === 200) {
          toast.success(response.message);
          navigate("/manage-goal");
        } else {
          toast.error(response.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  //service to delete goal
  const _deleteGoal = () => {
    const is_post = true;
    const payload = {
      goal_style_id: Number(id),
    };
    APIService(is_post, "goal/delete", payload)
      .then((response) => {
        if (response.status_code === 200) {
          setShowModal(false);
          toast.success(response.message);
          navigate("/manage-goal");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // --- handlers ---

  const _handleSave = () => {
  let hasError = false;

  // Reset all error messages first
  setLinkError(false);
  setTagError(false);
  setFileError(false);
  setMinSipError(false);
  setLumpsumError(false);

  if (!link.trim()) {
    setLinkError("Please enter a goal name.");
    hasError = true;
  }

  if (!tag.trim()) {
    setTagError("Please select a tag.");
    hasError = true;
  }

  if (!file) {
    setFileError("Please upload an image or file for this goal.");
    hasError = true;
  }

  if (!minSip || Number(minSip) <= 0) {
    setMinSipError("Please enter a valid minimum SIP amount greater than 0.");
    hasError = true;
  }

  if (!lumpsum || Number(lumpsum) <= 0) {
    setLumpsumError("Please enter a valid lumpsum amount greater than 0.");
    hasError = true;
  }

  if (hasError) return;

  _upsertGoalDetail();
};


  function _handleAuthorImageUpload(selectedFile) {
    setFileError(false);
    setFile(selectedFile);
  }

  return (
    <div className="row px-3 e-pt-20px e-primary-font-poppins">
      <div className="col-12 ">
        <div className="d-flex e-sidebar-nav-gradient e-border-radius-16 p-3 flex-column">
          {/* Header section */}
          <div className="d-flex flex-column justify-content-start">
            <div className="d-flex align-items-center column-gap-2">
              <div
                style={{ width: 45, height: 45 }}
                className="d-flex justify-content-center align-items-center  rounded-circle bg-white"
              >
                <img
                  src={file || imageLink}
                  width={40}
                  alt="Dream Home"
                  className="object-fit-cover"
                />
              </div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h4 className="e-primary-font-poppins text-white e-font-wight-500 e-font-18 line-height-18">
                  {link}
                </h4>
                <PrimaryButton
                  name="Delete Goal"
                  icon="delete"
                  onPress={() => {
                    setShowModal(true);
                  }}
                  size={16}
                  ClassName="bg-transparent px-0 e-text-cg-red e-font-weight-400 e-font-14 pe-3"
                />
              </div>
            </div>
            <PrimaryButton
              onPress={() => navigate("/manage-goal/view-rebalance")}
              type={2}
              icon="chevron_right"
              size="11px"
              ClassName="e-font-12 e-font-weight-500 px-1 bg-transparent border-0 e-w-fit e-text-lavender  "
              name="View rebalance history"
            />
          </div>
          {/* Card section */}
          <div className="d-flex pt-3 column-gap-2 row-gap-2 flex-wrap">
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-font-12 e-font-weight-400 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    Created on
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    {cardData.created_on}
                  </p>
                </div>
              </div>
            </div>
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-font-12 e-font-weight-400 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    CUSTOMERS INVESTED
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    {cardData.invested_users_count}
                  </p>
                </div>
              </div>
            </div>
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-font-12 e-font-weight-400 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    MIN SIP
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    ₹{cardData.minimum_sip}
                  </p>
                </div>
              </div>
            </div>
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-font-12 e-font-weight-400 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    MIN LUMPSUM
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    ₹{cardData.minimum_lumpsum}
                  </p>
                </div>
              </div>
            </div>

            {/* XIRR green
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px  ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-text-black e-font-12 e-font-weight-400 text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    3Y RETURNS
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 e-text-green e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    {cardData.return_percentage}
                  </p>
                </div>
              </div>
            </div> */}
            <div className="e-w-fit">
              <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="e-font-12 e-font-weight-400 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                    last updated
                  </h4>
                </div>
                <div>
                  <p className="e-font-18 text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                    {cardData.updated_on}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex min-vh-100 align-items-center justify-content-center">
          <Loader width={30} />
        </div>
      ) : (
        <div className="col-lg-8 pt-3">
          <div className="e-border-1px-pale-lavender e-border-radius-16 p-3 e-bg-ghost-white-dark">
            <h5 className="e-font-16 e-font-weight-600 e-text-eerie-black">
              Update details
            </h5>

            {/* Goal Name */}
            <div className="row pt-3">
              <Input
                id="goal-name"
                type="text"
                label="Goal Name"
                placeholder="Enter Goal name"
                require
                value={link}
                onKeyPress={_handleSave}
                autoFocus
                error={linkError}
                labelStyle="e-text-black e-font-weight-400 e-font-14 pb-2"
                className="w-100"
                handleChange={(val) => {
                  setLinkError(false);
                  setLink(val);
                }}
              />
            </div>

            {/* Tag */}
            <div className="row pt-3 align-items-center">
              <div className="d-flex justify-content-between">
                <h5 className="e-font-14 e-font-weight-500 e-text-black">
                  Tag <span className="text-danger">*</span>
                </h5>
                <div className="d-flex align-items-center mb-2">
                  <img
                    src={
                      require("../../Assets/Image/ManageBasket/info.svg")
                        .default
                    }
                    alt="info"
                  />
                  <p className="ps-2 e-font-12 m-0 e-font-weight-500">
                    You can only add a tag
                  </p>
                </div>
              </div>
              <div className="col-7">
                <Input
                  require
                  className="w-100"
                  value={tag}
                  onKeyPress={_handleSave}
                  type={"text"}
                  error={tagError}
                  handleChange={(val) => {
                    setTagError(false);
                    setTag(val);
                  }}
                />
              </div>
            </div>

            {/* Show tag toggle */}
            <div className="row py-2">
              <div className="col">
                <ToggleInput
                  label={" Show recommend tag in card"}
                  checked={recommended}
                  onChange={setRecommended}
                  labelStyle={
                    " e-font-primary-poppins e-font-14 e-font-weight-400 e-text-eerie-black"
                  }
                />
              </div>
            </div>

            {/* Upload Image */}
            <div className="pt-3">
              <h5 className="e-font-14 e-font-weight-400 text-capitalize pb-2">
                Upload goal image<span className="text-danger">*</span>
              </h5>
              <CustomFileUpload
                file={file || imageLink}
                type={1}
                fileSize={10}
                handleClear={() => {
                  setFile(null);
                  setFileError(false);
                  setImageLink("");
                }}
                onKeyPress={_handleSave}
                error={fileError}
                handleChange={_handleAuthorImageUpload}
                onUploadComplete={(url) => setImageLink(url)}
              />
            </div>
          </div>

          {/* Min SIP & Lumpsum */}
          <div className="row pt-3">
            <div className="col">
              <div className="e-border-1px-pale-lavender e-border-radius-16 p-3 e-bg-ghost-white-dark">
                <h5 className="e-font-16 p-0 m-0 e-font-weight-600 e-text-eerie-black">
                  Min SIP & Lumpsum
                </h5>
                <div className="row row-cols-2">
                  <div className="col-12">
                    <div className="d-flex align-items-center py-3">
                      <img
                        src={
                          require("../../Assets/Image/ManageBasket/info.svg")
                            .default
                        }
                        alt="info"
                      />
                      <p className="ps-2 e-font-12 m-0 e-font-weight-500">
                        By default we calculate min amount based on selected
                        basket. In case you want a min amount for basket, setup
                        this.
                      </p>
                    </div>
                  </div>
                  <div className="col position-relative">
                    <Input
                      label="Min SIP"
                      require
                      type="number"
                      className="w-100 ps-4"
                      value={minSip}
                      error={minSipError}
                      onKeyPress={_handleSave}
                      handleChange={(val) => {
                        setMinSipError(false);
                        setMinSip(val);
                      }}
                    />
                    <span className="e-money-marker">₹</span>
                  </div>
                  <div className="col position-relative">
                    <Input
                      label="Min Lumpsum"
                      require
                      type="number"
                      className="w-100 ps-4"
                      value={lumpsum}
                      error={lumpsumError}
                      onKeyPress={_handleSave}
                      handleChange={(val) => {
                        setLumpsumError(false);
                        setLumpSum(val);
                      }}
                    />
                    <span className="e-money-marker">₹</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="row e-pt-36px">
            <div className="offset-lg-2 col-lg-10 col-12">
              <div className="row">
                <div className="col-6">
                  <PrimaryButton
                    ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet"
                    name="Cancel"
                    onPress={() => navigate("/manage-goal")}
                  />
                </div>
                <div className="col-6">
                  <PrimaryButton
                    ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white"
                    name="Save"
                    onPress={_handleSave}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <DeleteModal
          image={require("../../Assets/Image/bakset_Del.png")}
          title={"Delete Goal?"}
          message={
            "Are you sure you want to delete this Goal? Deleting this would result in removing it from the user app."
          }
          close={() => setShowModal(false)}
          onClick={_deleteGoal}
        />
      )}
    </div>
  );
}
